import {Component, OnDestroy, OnInit} from '@angular/core';
import { LoggingService, ResizeService} from 'mclane-apptemplate-lib';
import {AuthServicesService} from 'mclane-webauth-lib';
import {InvoiceProcessingService} from '~/app/core/services/invoice-processing.service';
import {HomeOffice} from '@model/HomeOffice';
import {UserService} from '~/app/core/services/user.service';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-Home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public today: Date = new Date();
  public homeOffices: HomeOffice[] = [];
  public selectedHomeOffice: HomeOffice;
  public display: string;


  constructor(public resizeService: ResizeService,
              public console: LoggingService,
              public authService: AuthServicesService,
              public invoiceProcessingService: InvoiceProcessingService,
              public userService: UserService,
              public loadingIndicator: LoadingIndicatorHelper) {
    this.resizeService.screenChange.subscribe((event) => {
      this.console.log(event);
    });
  }

  async ngOnInit() {
    this.loadingIndicator.show();
    this.homeOffices = await this.invoiceProcessingService.getHoList(this.authService.getUsername());
    if (this.homeOffices.length > 0) {

      this.homeOffices.forEach(homeOffice => {
        homeOffice.display = homeOffice.hoDesc + ' (HO#' + homeOffice.hoId + ')';
      });


      if (this.userService.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.userService.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.selectedHomeOffice = this.userService.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.userService.userHomeOffice(this.selectedHomeOffice);
      } else {
        this.selectedHomeOffice = this.homeOffices[0];
        this.userService.userHomeOffice(this.selectedHomeOffice);
      }

      this.display = this.selectedHomeOffice.hoDesc;
    }
    this.loadingIndicator.hide();
  }

  homeOfficesValueChange(value: any) {
    this.display = this.selectedHomeOffice.hoDesc;
    this.userService.userHomeOffice(this.selectedHomeOffice);
  }

  ngOnDestroy() {
  }
}
